import React from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, useLocation } from "react-router";

// Constants
import { ROUTE } from '../../../constants'

/**
 * Components
 */
import { asyncComponent } from '../../../components'

 /**
 * Pages
 */
import SSOPanel from '../../../pages/SSOPanel'
import SSOLogin from '../../../pages/SSOLogin'
import SSOLoading from '../../../pages/SSOLoading'
import LiveTrackingMap from '../../../pages/LiveTrackingMap';
import TabletView from '../../../pages/TabletView';
import TripChecklist from '../../../pages/TripChecklist';

const AsyncNotFoundPage = asyncComponent(() => import("../../../pages/NotFoundPage"));

const AuthSelector = () => {

    const auth = useSelector(state => state.root.auth)

    const location = useLocation()
    const param = new URLSearchParams(location.search)
    
    const pathName = location.pathname
    const isParamsAvailable = pathName === '/livetracking' || pathName === '/pretrip'

    const _authSelector = () => {
        if(auth.loadingState) {
            return <SSOLoading />
        } else {
            if(isParamsAvailable) {
                switch(pathName) {
                    case '/livetracking': {
                        return <LiveTrackingMap trackid={param.get("trackid")}/>
                    }
                    case '/pretrip': {
                        return <TripChecklist param={param}/>
                    }
                    default: 
                        break;
                }
            }
            else if(auth.currentUser) {
                if(pathName === '/tablet') {
                    const plate = decodeURIComponent(location.search?.split('plate=')[1].split('&')[0])
                    
                    return <TabletView plate={plate} />
                }
                else return <SSOPanel currentUser={auth.currentUser}/>
            } else {
                return <SSOLogin />
            }
        }
    }

    return (
        <>
        {
            _authSelector()
        }
        </>
    )
}

const SSORoutes = () => {

    return (
        <>
            <Routes>

                <Route
                    exact
                    path={ROUTE.MODULE_ROUTE.Login}
                    element={<SSOLogin/>}
                />

                <Route 
                    index
                    path={ROUTE.MODULE_ROUTE.Landing_Page} 
                    element={<AuthSelector />}
                />

                <Route element={<AsyncNotFoundPage />}/>

            </Routes>
        </>
    )
}

export default SSORoutes;